import React from 'react'
import { Card } from './styled'
import { SubTitle, Text1Bold } from '../ui/text'
import colors from '../../styled/colors'


const InfoCard = ({ title, subtitle, titleColor=colors.text.primaryText, subtitleColor=colors.text.primaryText }) => {
	return (
		<Card>
			<Text1Bold style={{ color: titleColor }}>{title}</Text1Bold>
			{React.isValidElement(subtitle) ? (
				subtitle
			) : (
				<SubTitle style={{ color: subtitleColor }}>{subtitle}</SubTitle>
			)}
		</Card>
	)
}

export default InfoCard

